import React, { useState } from 'react';
import './AllFeaturePage.css';
import file from '../../assets/images/file.svg';
import facefinder from '../../assets/images/facefinder.png';
import ssFinder from '../../assets/images/SS_finder.png';
import rect from '../../assets/images/rect.png';
import swap from '../../assets/images/swap.svg';
import CnU from '../../assets/images/CnU.png';
import arrow1 from '../../assets/images/arrow1.svg';
import darkblue from '../../assets/images/darkblue.svg';
import RnS from '../../assets/images/RnS.svg';
import MnO from '../../assets/images/MnO.svg';
import img1 from '../../assets/images/i1.svg';
import img2 from '../../assets/images/i2.svg';
import img3 from '../../assets/images/i3.svg';
import img4 from '../../assets/images/i4.svg';


const FEATURE_CARDS = [
  {
    title: 'Seamless multi-format file upload',
    description:
      'Effortlessly upload and manage assets in multiple formats with a seamless experience',
    icon: img1,
  },
  {
    title: 'Secure Asset Storage & Access',
    description:
      'Safely store and access assets with robust security and controlled permissions',
    icon: img2,
  },
  {
    title: 'Easy Bulk Upload with Drag & Drop',
    description:
      'Quickly upload multiple assets with a simple drag-and-drop interface',
    icon: img3,
  },
  {
    title: 'On the go Asset Editing/Cropping',
    description:
      'Edit and crop assets on the go with quick and intuitive tools',
    icon: img4,
  },
];

const AllFeaturePage = () => {
  const [selectedCTA, setSelectedCTA] = useState('create');

  const workflowImages = {
    create: rect,
    manage: MnO,
    retrieve: RnS,
  };

  const ctaDescriptions = {
    create: 'Effortlessly create folders and upload assets in a few clicks',
    manage: 'Effortlessly manage and organize assets for seamless workflow',
    retrieve: 'Quickly access and share assets with seamless collaboration',
  };

  return (
    <section className="all-features-section">
      <div className="features-container1">
        <header className="features-header">
          <h1 className="features-title">Explore the Smart Features <br/> Behind Effortless DAM.</h1>
          <p className="features-description">
          Whether you're uploading, editing, or accessing—our platform simplifies every task.
          </p>
        </header>
        <div className="features-grid">
          {FEATURE_CARDS.map((card, index) => (
            <article key={index} className="feature-card">
              <img
                src={card.icon}
                alt={`${card.title} icon`}
                className="feature-icon"
              />
              <h3 className="feature-card-title">{card.title}</h3>
              <p className="feature-card-description">{card.description}</p>
            </article>
          ))}
        </div>
      </div>
     
    </section>
  );
};

export default AllFeaturePage;
